import analytics from '@utils/analytics';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
const ProductFilterCheckbox = (props) => {
    const { refinement, refinementValue, index } = props;
    const refinementKey = refinementValue.id + '-' + refinementValue.displayValue;
    const [checked, setChecked] = useState();
    useEffect(() => {
        setChecked(refinementValue.selected);
    }, [refinementValue.selected]);
    const onInteract = () => {
        if (refinementValue.selectable || refinementValue.selected) {
            props.addFilterValue(refinement.attributeID, refinementValue.displayValue);
            if (props.fromSearch) {
                analytics.searchRefineSecondLevel(refinement.attributeID, refinementValue.presentationId || refinementValue.displayValue);
                analytics.searchRefineMacrocategory(window.location.search);
            }
            else {
                analytics.refineSecondLevel(refinement.attributeID, refinementValue.presentationId || refinementValue.displayValue);
                analytics.refineMacrocategory(window.location.search);
            }
        }
    };
    return (React.createElement("li", { key: refinementKey, className: classNames('filters__menu__menuitem', { disabled: !refinementValue.selectable }) },
        React.createElement("input", { type: "checkbox", name: refinementValue.id, value: refinementValue.displayValue, id: refinementValue.id + '-' + refinementValue.presentationId + '-' + index, onChange: (e) => {
                setChecked(!checked);
                onInteract();
            }, checked: checked, disabled: !refinementValue.selectable && !refinementValue.selected }),
        React.createElement("label", { htmlFor: refinementValue.id + '-' + refinementValue.presentationId + '-' + index }, refinementValue.link ? (React.createElement("a", { onClick: (e) => {
                e.preventDefault();
                onInteract();
            }, href: refinementValue.link },
            refinementValue.type === 'color' && React.createElement("span", { className: `swatch swatch--${refinementValue.presentationId}` }),
            refinementValue.displayValue)) : (React.createElement(React.Fragment, null,
            refinementValue.type === 'color' && React.createElement("span", { className: `swatch swatch--${refinementValue.presentationId}` }),
            refinementValue.displayValue)))));
};
export default ProductFilterCheckbox;
